export default __webpack_public_path__ + "static/media/bruce-hamilton-320.3bb502dd.jpg";